import { formErrorAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  formErrorAnatomy.keys
);

const baseStyleText = defineStyle({
  position: "absolute",
  left: 0,
  bottom: 0,
  zIndex: 4,
  whiteSpace: "noWrap",
});

const baseStyle = definePartsStyle({
  text: baseStyleText,
});

export const formErrorTheme = defineMultiStyleConfig({ baseStyle });
